import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"
import {
	getUserById,
	getPermissionsByUserId,
	updateUserById,
	User,
	UserPermission,
} from "@shared/api"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	userData: User | undefined
	userPermissions: UserPermission[] | undefined
}

type Actions = {
	fetchUserProfile: (apiClient: APIClient, userId?: string) => Promise<void>
	fetchUserPermissions: (
		apiClient: APIClient,
		userId?: string,
	) => Promise<UserPermission[] | undefined>
	updateUserProfile: (
		apiClient: APIClient,
		userId: string,
		patch: Partial<User>,
	) => Promise<void>
}

export const useAuthStore = create<State & Actions>()(
	immer((set, get) => ({
		userData: undefined,
		userPermissions: undefined,

		fetchUserProfile: async (apiClient: APIClient, userId?: string) => {
			if (!userId) {
				return
			}

			const response = await getUserById(apiClient, userId)

			set(state => {
				state.userData = response
			})
		},
		fetchUserPermissions: async (apiClient: APIClient, userId?: string) => {
			if (!userId) {
				return get().userPermissions
			}

			const response = await getPermissionsByUserId(apiClient, userId)

			response.forEach(permission => {
				const dataScope = permission.dataScope as string
				permission.dataScope = JSON.parse(dataScope)
			})

			set(state => {
				state.userPermissions = response
			})

			return get().userPermissions
		},
		updateUserProfile: async (
			apiClient: APIClient,
			userId: string,
			patch: Partial<User>,
		) => {
			if (!userId) {
				return
			}

			const response = await updateUserById(apiClient, userId, patch)

			set(state => {
				state.userData = response
			})
		},
	})),
)
